import Skeleton from '@mui/material/Skeleton';
import TableCell from '../TableCell';
import TableRow, { type TableRowProps } from '../TableRow';
import { classes, styles } from './utils';

export interface SkeletonRowProps extends TableRowProps {
  delay?: number;
  duration?: number;
  size?: number;
}

export default function SkeletonRow({
  delay = 0.2,
  duration = 1.2,
  size = 1,
  ...props
}: SkeletonRowProps) {
  return (
    <TableRow {...props}>
      <TableCell className={classes.tableCell} colSpan={size}>
        <Skeleton
          sx={styles.skeleton(delay, duration)}
          className={classes.skeleton}
          variant="rectangular"
          animation="wave"
        />
      </TableCell>
    </TableRow>
  );
}
